import LeagueManagementCard from "./LeagueManagementCard";
import { useState } from "react";
import type { LeagueSummary } from "@tnp/contracts";
import AppSelect from "../../../../shared/components/AppSelect";
import EmptyState from "../../../../shared/components/EmptyState";
import SearchInput from "../../../../shared/components/SearchInput";
import { normalizeSearchText } from "../../../../shared/utils/searchText";
import { getLeagueTexts } from "../../shared/leagueTexts";
import { getLeagueFlowTexts } from "../leagueFlowTexts";

export default function LeagueManagementList({ items, onEdit, onDelete }: { items: LeagueSummary[]; onEdit: (id: string) => void; onDelete?: (league: LeagueSummary) => void }) {
  const t = getLeagueTexts();
  const f = getLeagueFlowTexts();
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const filtered = items.filter(league => (!status || league.status === status) && normalizeSearchText(`${league.name} ${league.venue} ${league.organizerName}`).includes(normalizeSearchText(query)));
  return <div className="league-panel league-management-list">
    <div className="league-list-filters">
      <SearchInput aria-label={f.search} placeholder={f.search} value={query} onChange={event => setQuery(event.target.value)} onClear={() => setQuery("")} />
      <AppSelect aria-label={t.statusLabel} value={status} onChange={event => setStatus(event.target.value)}>
        <option value="">{f.all}</option><option value="draft">{t.draft}</option><option value="published">{t.published}</option><option value="archived">{t.archived}</option>
      </AppSelect>
    </div>
    {!filtered.length ? <EmptyState title={f.noMatches} iconName="emoji_events" /> : <div className="admin-tournaments-list">
      {filtered.map(league => <LeagueManagementCard key={league.id} league={league} onEdit={onEdit} onDelete={onDelete} />)}
    </div>}
  </div>;
}
